<template>
  <div class="markdown-view" v-html="rendered"></div>
</template>

<script>
import { marked } from 'marked'

marked.setOptions({
  breaks: true,
  gfm: true,
})

export default {
  name: 'MarkdownView',
  props: {
    source: { type: String, default: '' },
  },
  computed: {
    rendered() {
      if (!this.source) return ''
      return marked.parse(this.source)
    },
  },
}
</script>

<style lang="scss" scoped>
.markdown-view {
  color: #051B30;

  ::v-deep {
    h1, h2, h3, h4, h5, h6 { margin: 0.5em 0; color: #051B30; }
    p { margin: 0.5em 0; color: #051B30; }
    strong { color: #051B30; }
    li { color: #051B30; }
    ul, ol { padding-left: 1.25em; }
    code {
      background: #f4f4f4;
      padding: 2px 4px;
      border-radius: 3px;
    }
    pre code { display: block; padding: 8px; }
    a { color: var(--primary-color, #1976d2); }
  }
}
</style>
